import { datadogRum } from '@datadog/browser-rum';
import { useEffect } from 'react';

import { useAuth } from '~/hooks/useAuth';

export function initializeDatadogRum() {
  const VITE_STAGE = import.meta.env.VITE_STAGE;
  const VITE_DDRUM_APP_ID = import.meta.env.VITE_DDRUM_APP_ID;
  const VITE_DDRUM_CLIENT_TOKEN = import.meta.env.VITE_DDRUM_CLIENT_TOKEN;
  const GIT_COMMIT_SHA = import.meta.env.VITE_GIT_COMMIT_SHA;
  const API_GATEWAY_URL = import.meta.env.VITE_API_URL;

  if (['staging', 'uat', 'prod'].includes(VITE_STAGE)) {
    datadogRum.init({
      applicationId: VITE_DDRUM_APP_ID,
      clientToken: VITE_DDRUM_CLIENT_TOKEN,
      site: 'datadoghq.com',
      service: 'enterprise-dashboard',
      env: VITE_STAGE,
      // Specify a version number to identify the deployed version of your application in Datadog
      version: GIT_COMMIT_SHA,
      sessionSampleRate: 100,
      sessionReplaySampleRate: 100,
      defaultPrivacyLevel: 'mask-user-input',
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      silentMultipleInit: true,
      allowedTracingUrls: [API_GATEWAY_URL],
      enableExperimentalFeatures: ['feature_flags'],
    });
  }
}

export const DatadogRum = () => {
  const { user } = useAuth();
  initializeDatadogRum();

  useEffect(() => {
    if (user?.sub) {
      datadogRum.setUser({
        id: user.sub,
        email: user.email,
        enterprisePartnerId: user.enterprisePartnerId,
        roles: user.roles,
      });
    }
  }, [user]);

  return null;
};
